import React, { useCallback, useEffect, useState } from "react";
import { IconButton, Badge } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../utils/api";
import {
  normalizeNotificationsResponse,
  isMessageNotification,
  isUnreadNotification,
} from "../../utils/notificationPayload";

const MessageNotificationsButton = () => {
  const { fetchUnreadNotifications } = useApi();
  const navigate = useNavigate();
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const raw = await fetchUnreadNotifications();
      const list = normalizeNotificationsResponse(raw);
      const count = list.filter(
        (n) => isUnreadNotification(n) && isMessageNotification(n)
      ).length;
      setUnreadMessagesCount(count);
    } catch {
      setUnreadMessagesCount(0);
    }
  }, [fetchUnreadNotifications]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [load]);

  return (
    <IconButton
      aria-label="Messages"
      onClick={() => navigate("/messaging")}
      sx={{ color: "white" }}
    >
      <Badge
        badgeContent={unreadMessagesCount}
        max={99}
        invisible={unreadMessagesCount === 0}
        sx={{
          "& .MuiBadge-badge": {
            backgroundColor: "#000",
            color: "#fff",
          },
        }}
      >
        <MessageIcon fontSize="large" />
      </Badge>
    </IconButton>
  );
};

export default MessageNotificationsButton;
